/* American Threads Co - COMBO BUILDER for Teeinblue products (2026-10-30, SP036)
   Andi wants a "Combo" choice next to the normal single shirt: the shopper
   picks how many shirts (2 to 5) and then a design, colour, size (and their
   own text for "Custom Text") for EACH shirt, with a preview of that shirt.
 
   Teeinblue renders only one personalised shirt, so the combo is drawn by
   this script. Each shirt goes to the cart as its own line of the real
   variant (right colour and size, right price) with line item properties
   (Design, Your Text, Combo). The combo price cut is a Shopify automatic
   discount on this product with a minimum quantity, so the tiers below are
   only what we SHOW; the discount itself lives in Shopify admin.
 
   The preview is layered images, not a canvas: blank shirt photo, design
   PNG scaled into the print box, and for Custom Text a text box in Anton.
 
   Everything product specific comes from the json metafield
   atc.combo_builder (see snippets/atc-combo-builder.liquid). */
(function () {
  var cfgEl = document.getElementById('atc-combo-config');
  var varEl = document.getElementById('atc-combo-variants');
  if (!cfgEl || !varEl) return;
  var C, V;
  try { C = JSON.parse(cfgEl.textContent); V = JSON.parse(varEl.textContent); } catch (e) { return; }
  if (!C || !C.designs || !C.colors) return;
 
  var MIN = C.min || 2, MAX = C.max || 5;
  var colorNames = Object.keys(C.colors);
  var sizes = C.sizes || ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  var st = {
    on: false, n: MIN, active: 0,
    shirts: []
  };
  for (var i = 0; i < MAX; i++) {
    st.shirts.push({
      design: C.designs[(C.start_designs && C.start_designs[i] != null) ? C.start_designs[i] : i % C.designs.length].name,
      color: (C.start_colors && C.start_colors[i]) || colorNames[i % colorNames.length],
      size: null, text: ''
    });
  }
 
  function $(sel, root) { return (root || document).querySelector(sel); }
  function h(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function design(name) { for (var i = 0; i < C.designs.length; i++) if (C.designs[i].name === name) return C.designs[i]; return C.designs[0]; }
  function ink(color) { return (C.light || []).indexOf(color) !== -1 ? 'rg' : 'cream'; }
  function variant(color, size) {
    for (var i = 0; i < V.length; i++) {
      var o = V[i].options;
      if (o.indexOf(color) !== -1 && o.indexOf(size) !== -1) return V[i];
    }
    return null;
  }
  function tier(n) { return (C.tiers && C.tiers[String(n)]) || 0; }
  function maxTier() { var m = 0; for (var k in (C.tiers || {})) m = Math.max(m, C.tiers[k]); return m; }
 
  /* ---------- styles ---------- */
  var css = h('style');
  css.textContent = [
    'html.atc-cb-on .tee-form-wrapper, html.atc-cb-on buy-buttons-component, html.atc-cb-on .product-form-buttons,',
    'html.atc-cb-on sticky-add-to-cart, html.atc-cb-on .sticky-add-to-cart, html.atc-cb-on .product-details variant-picker{display:none!important;}',
    '.atc-cb{margin:0 0 18px;}',
    '.atc-cb__mode{display:flex;gap:10px;margin:0 0 16px;}',
    '.atc-cb__mode button{flex:1;padding:12px 10px;border:1px solid currentColor;background:transparent;color:inherit;font:inherit;font-weight:700;cursor:pointer;line-height:1.25;}',
    '.atc-cb__mode button[aria-pressed=true]{background:#1A2821;color:#fff;border-color:#1A2821;}',
    '.atc-cb__mode small{display:block;font-weight:700;color:#A3161C;font-size:13px;}',
    '.atc-cb__mode button[aria-pressed=true] small{color:#ffd6d6;}',
    '.atc-cb__body{display:none;}',
    'html.atc-cb-on .atc-cb__body{display:block;}',
    '.atc-cb__h{font-size:16px;font-weight:700;margin:0 0 10px;}',
    '.atc-cb__h span{font-weight:400;}',
    '.atc-cb__row{display:flex;flex-wrap:nowrap;gap:8px;overflow-x:auto;scrollbar-width:none;padding-bottom:4px;margin:0 0 14px;}',
    '.atc-cb__row::-webkit-scrollbar{display:none;}',
    '.atc-cb__row--wrap{flex-wrap:wrap;overflow:visible;}',
    '.atc-cb__pill{flex:0 0 auto;padding:9px 14px;border:1px solid rgba(0,0,0,.35);background:#fff;color:#111;font:inherit;font-size:14px;cursor:pointer;line-height:1.2;}',
    '.atc-cb__pill[aria-pressed=true]{background:#1A2821;color:#fff;border-color:#1A2821;}',
    '.atc-cb__pill small{display:block;font-size:11px;color:#A3161C;font-weight:700;}',
    '.atc-cb__pill[aria-pressed=true] small{color:#ffd6d6;}',
    '.atc-cb__sw{flex:0 0 auto;width:36px;height:36px;border-radius:50%;border:2px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,.35);cursor:pointer;padding:0;}',
    '.atc-cb__sw[aria-pressed=true]{box-shadow:0 0 0 2px #1A2821;}',
    '.atc-cb__card{border:1px solid rgba(0,0,0,.15);padding:12px;margin:0 0 14px;}',
    '.atc-cb__card.is-active{border-color:#1A2821;box-shadow:0 0 0 1px #1A2821;}',
    '.atc-cb__top{display:flex;gap:12px;align-items:flex-start;margin:0 0 12px;}',
    '.atc-cb__top .atc-cb__pv{width:118px;flex:0 0 118px;}',
    '.atc-cb__title{font-size:17px;font-weight:700;margin:2px 0 4px;}',
    '.atc-cb__sub{font-size:13px;opacity:.8;line-height:1.35;}',
    '.atc-cb__pv{position:relative;aspect-ratio:1/1;overflow:hidden;background:#eee;}',
    '.atc-cb__pv img{position:absolute;display:block;max-width:none;}',
    '.atc-cb__pv .atc-cb__blank{left:0;top:0;width:100%;height:100%;}',
    '.atc-cb__txt{position:absolute;display:flex;align-items:center;justify-content:center;text-align:center;',
    'font-family:"Anton",Impact,"Arial Narrow",sans-serif;text-transform:uppercase;line-height:1.08;word-break:break-word;}',
    '.atc-cb__txt span{display:block;width:100%;}',
    '.atc-cb__in{width:100%;box-sizing:border-box;padding:11px 12px;border:1px solid rgba(0,0,0,.4);font:inherit;font-size:16px;margin:0 0 4px;}',
    '.atc-cb__hint{font-size:12px;opacity:.75;margin:0 0 12px;}',
    '.atc-cb__err{color:#A3161C;font-size:13px;font-weight:700;margin:4px 0 8px;}',
    '.atc-cb__sum{margin:6px 0 12px;font-size:15px;line-height:1.45;}',
    '.atc-cb__sum s{opacity:.6;margin-right:6px;}',
    '.atc-cb__sum b{color:#A3161C;font-size:20px;}',
    '.atc-cb__save{color:#A3161C;font-weight:700;}',
    '.atc-cb__add{display:block;width:100%;padding:15px;background:#1A2821;color:#fff;border:0;font:inherit;font-weight:700;font-size:16px;cursor:pointer;}',
    '.atc-cb__add[disabled]{opacity:.6;cursor:wait;}',
    '.atc-cb__ok{margin:10px 0 0;font-weight:700;}',
    '.atc-cb-stage{position:absolute;inset:0;z-index:5;background:#fff;display:none;}',
    'html.atc-cb-on .atc-cb-stage.is-on{display:block;}',
    '.atc-cb-stage__in{position:sticky;top:var(--atc-cb-top,0px);width:100%;max-width:calc(100vh - var(--atc-cb-top,0px) - 20px);margin:0 auto;aspect-ratio:1/1;}',
    '.atc-cb-stage .atc-cb__pv{width:100%;height:100%;}',
    '.atc-cb-stage__tag{position:absolute;left:10px;top:10px;z-index:2;background:#1A2821;color:#fff;font-size:13px;font-weight:700;padding:5px 9px;}',
    '.atc-cb-stage__x{position:absolute;right:10px;top:10px;z-index:2;width:34px;height:34px;border-radius:50%;border:0;background:rgba(255,255,255,.9);font-size:20px;line-height:34px;cursor:pointer;}'
  ].join('');
  document.head.appendChild(css);
  if (C.font_css && !document.getElementById('atc-cb-font')) {
    var lk = h('link'); lk.id = 'atc-cb-font'; lk.rel = 'stylesheet'; lk.href = C.font_css;
    document.head.appendChild(lk);
  }
 
  /* ---------- preview ---------- */
  function preview(sh) {
    var box = h('div', 'atc-cb__pv');
    var col = C.colors[sh.color] || {};
    var b = h('img', 'atc-cb__blank'); b.alt = sh.color + ' shirt'; b.src = col.img || ''; b.loading = 'lazy';
    box.appendChild(b);
    var d = design(sh.design);
    var k = ink(sh.color);
    var src = d[k];
    var pb = C.box; /* x,y,w,h on an 800 px square */
    var s = Math.min(pb[2] / d.w, pb[3] / d.h);
    var w = d.w * s, hh = d.h * s;
    var x = pb[0] + (pb[2] - w) / 2, y = pb[1];
    if (src) {
      var di = h('img'); di.alt = sh.design; di.src = src;
      di.style.left = (x / 8) + '%'; di.style.top = (y / 8) + '%';
      di.style.width = (w / 8) + '%'; di.style.height = (hh / 8) + '%';
      box.appendChild(di);
    }
    if (d.custom && d.text_box) {
      var tb = d.text_box; /* in design px */
      var t = h('div', 'atc-cb__txt');
      t.style.left = ((x + tb[0] * s) / 8) + '%';
      t.style.top = ((y + tb[1] * s) / 8) + '%';
      t.style.width = (tb[2] * s / 8) + '%';
      t.style.padding = '0 ' + (tb[2] * s / 8 * 0.04) + '%';
      t.style.boxSizing = 'border-box';
      t.style.height = (tb[3] * s / 8) + '%';
      t.style.color = (C.ink_text || {})[k] || (k === 'rg' ? '#C8232C' : '#F3EAD6');
      var sp = h('span', null, sh.text || C.custom_placeholder || 'YOUR TEXT');
      t.appendChild(sp);
      box.appendChild(t);
      fitLater(t);
    }
    return box;
  }
 
  /* parse a fetch response as JSON; HTML (bot check, error page) gives {} instead of a raw parse error */
  function safeJson(r) {
    return r.text().then(function (t) { try { return JSON.parse(t); } catch (e) { return {}; } });
  }
 
  /* shrink the custom text until it fits its box (max 3 lines) */
  function fit(t) {
    var cs = getComputedStyle(t);
    var W = t.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight), H = t.clientHeight;
    if (!W || !H) return false;
    var span = t.firstChild;
    var lo = 4, hi = H, best = lo;
    for (var i = 0; i < 14; i++) {
      var mid = (lo + hi) / 2;
      t.style.fontSize = mid + 'px';
      var lines = span.offsetHeight / (mid * 1.08);
      if (span.scrollWidth <= W + 1 && span.offsetHeight <= H + 1 && lines < 3.5) { best = mid; lo = mid; } else { hi = mid; }
    }
    t.style.fontSize = best + 'px';
    return true;
  }
  function fitLater(t) {
    var tries = 0;
    var go = function () { if (!document.contains(t)) return; if (!fit(t) && tries++ < 20) setTimeout(go, 120); };
    requestAnimationFrame(go);
    /* the column can change width without a window resize (Horizon's cart drawer squeezes the page) */
    if (window.ResizeObserver) new ResizeObserver(function () { if (document.contains(t)) fit(t); }).observe(t);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (document.contains(t)) fit(t); });
  }
  window.addEventListener('resize', function () {
    [].forEach.call(document.querySelectorAll('.atc-cb__txt'), fit);
  });
 
  /* big preview over the product gallery (it stays sticky on mobile) */
  function stage() {
    var media = $(C.gallery_selector || '.product-information__media');
    if (!media) return null;
    var el = media.querySelector(':scope > .atc-cb-stage');
    if (!el) {
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      el = h('div', 'atc-cb-stage');
      media.appendChild(el);
    }
    return el;
  }
  var stageHidden = false;
  function drawStage() {
    var el = stage();
    if (!el) return;
    el.innerHTML = '';
    /* the gallery column can be much taller than wide on desktop: keep a square preview pinned under the sticky header */
    var hdr = $('#header-group') || $('header-component') || $('header');
    var top = 0;
    if (hdr) { var r = hdr.getBoundingClientRect(); if (r.bottom > 0 && r.bottom < 320) top = Math.round(r.bottom); }
    el.style.setProperty('--atc-cb-top', top + 'px');
    var inn = h('div', 'atc-cb-stage__in');
    el.appendChild(inn);
    var sh = st.shirts[st.active];
    var pv = preview(sh);
    inn.appendChild(pv);
    inn.appendChild(h('div', 'atc-cb-stage__tag', 'Shirt ' + (st.active + 1) + ' of ' + st.n + ' preview'));
    var x = h('button', 'atc-cb-stage__x', '×');
    x.type = 'button'; x.setAttribute('aria-label', 'Show product photos');
    x.addEventListener('click', function () { stageHidden = true; el.classList.remove('is-on'); });
    inn.appendChild(x);
    el.classList.toggle('is-on', st.on && !stageHidden);
  }
 
  /* ---------- UI ---------- */
  var root = h('div', 'atc-cb');
  var body = h('div', 'atc-cb__body');
 
  function pill(label, pressed, sub) {
    var b = h('button', 'atc-cb__pill', label);
    b.type = 'button';
    b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    if (sub) b.appendChild(h('small', null, sub));
    return b;
  }
 
  function modeRow() {
    var row = h('div', 'atc-cb__mode');
    var one = h('button', null, C.single_label || '1 Shirt');
    one.type = 'button';
    one.setAttribute('aria-pressed', st.on ? 'false' : 'true');
    var combo = h('button', null, C.combo_label || ('Combo ' + MIN + '–' + MAX + ' Shirts'));
    combo.type = 'button';
    combo.setAttribute('aria-pressed', st.on ? 'true' : 'false');
    if (maxTier()) combo.appendChild(h('small', null, 'Save up to ' + maxTier() + '%'));
    one.addEventListener('click', function () { setOn(false); });
    combo.addEventListener('click', function () { setOn(true); });
    row.appendChild(one); row.appendChild(combo);
    return row;
  }
 
  function setOn(on) {
    st.on = on;
    stageHidden = false;
    document.documentElement.classList.toggle('atc-cb-on', on);
    render();
  }
 
  function card(i) {
    var sh = st.shirts[i];
    var c = h('div', 'atc-cb__card' + (i === st.active ? ' is-active' : ''));
    c.setAttribute('data-shirt', i);
    var top = h('div', 'atc-cb__top');
    var pv = preview(sh);
    pv.style.cursor = 'zoom-in';
    pv.addEventListener('click', function () { st.active = i; stageHidden = false; drawStage(); scrollToStage(); });
    top.appendChild(pv);
    var info = h('div');
    info.appendChild(h('div', 'atc-cb__title', 'Shirt ' + (i + 1)));
    var v = sh.size ? variant(sh.color, sh.size) : null;
    info.appendChild(h('div', 'atc-cb__sub', sh.design + ' · ' + sh.color + ' · ' + (sh.size || 'pick a size') + (v ? ' · ' + money(v.price) : '')));
    top.appendChild(info);
    c.appendChild(top);
 
    function touch() { st.active = i; stageHidden = false; }
 
    var hd = h('div', 'atc-cb__h', 'Design: '); hd.appendChild(h('span', null, sh.design));
    c.appendChild(hd);
    var dr = h('div', 'atc-cb__row atc-cb__row--wrap');
    C.designs.forEach(function (d) {
      var b = pill(d.name, d.name === sh.design);
      b.addEventListener('click', function () { sh.design = d.name; touch(); render(); });
      dr.appendChild(b);
    });
    c.appendChild(dr);
 
    if (design(sh.design).custom) {
      c.appendChild(h('div', 'atc-cb__h', 'Your Text'));
      var inp = h('input', 'atc-cb__in');
      inp.type = 'text';
      inp.maxLength = design(sh.design).maxlen || 30;
      inp.placeholder = C.custom_placeholder || 'YOUR TEXT';
      inp.value = sh.text;
      inp.addEventListener('input', function () {
        sh.text = inp.value;
        touch();
        /* refresh only the previews, keep the keyboard open */
        var old = c.querySelector('.atc-cb__pv');
        var nu = preview(sh);
        nu.style.cursor = 'zoom-in';
        nu.addEventListener('click', function () { st.active = i; stageHidden = false; drawStage(); scrollToStage(); });
        old.parentNode.replaceChild(nu, old);
        drawStage();
      });
      c.appendChild(inp);
      c.appendChild(h('div', 'atc-cb__hint', 'Up to ' + inp.maxLength + ' characters, printed in capital letters inside the striped frame.'));
    }
 
    var hc = h('div', 'atc-cb__h', 'Color: '); hc.appendChild(h('span', null, sh.color));
    c.appendChild(hc);
    var cr = h('div', 'atc-cb__row');
    colorNames.forEach(function (name) {
      var b = h('button', 'atc-cb__sw');
      b.type = 'button';
      b.title = name; b.setAttribute('aria-label', name);
      b.style.background = C.colors[name].hex || '#ccc';
      b.setAttribute('aria-pressed', name === sh.color ? 'true' : 'false');
      b.addEventListener('click', function () { sh.color = name; touch(); render(); });
      cr.appendChild(b);
    });
    c.appendChild(cr);
 
    var hs = h('div', 'atc-cb__h', 'Size: '); hs.appendChild(h('span', null, sh.size || ''));
    c.appendChild(hs);
    var sr = h('div', 'atc-cb__row');
    sizes.forEach(function (sz) {
      var b = pill(sz, sz === sh.size);
      b.addEventListener('click', function () { sh.size = sz; touch(); render(); });
      sr.appendChild(b);
    });
    c.appendChild(sr);
    return c;
  }
 
  function summary() {
    var wrap = h('div');
    var total = 0, off = 0, ok = true;
    var pct = tier(st.n);
    for (var i = 0; i < st.n; i++) {
      var sh = st.shirts[i];
      var v = sh.size ? variant(sh.color, sh.size) : null;
      if (!v) { ok = false; continue; }
      total += v.price;
      off += Math.floor(v.price * pct / 100); /* Shopify takes the % per line, rounded down to the cent */
    }
    var sum = h('div', 'atc-cb__sum');
    if (ok) {
      var after = total - off;
      if (pct) { sum.appendChild(h('s', null, money(total))); }
      sum.appendChild(h('b', null, money(after)));
      sum.appendChild(document.createTextNode(' for ' + st.n + ' shirts'));
      if (pct) {
        sum.appendChild(h('br'));
        sum.appendChild(h('span', 'atc-cb__save', 'You save ' + money(total - after) + ' (' + pct + '% off, applied in cart)'));
      }
    } else {
      sum.appendChild(document.createTextNode('Pick a size for every shirt to see your combo price' + (pct ? ' (' + pct + '% off)' : '') + '.'));
    }
    wrap.appendChild(sum);
    var err = h('div', 'atc-cb__err'); err.style.display = 'none';
    wrap.appendChild(err);
    var add = h('button', 'atc-cb__add', 'Add ' + st.n + ' shirts to cart');
    add.type = 'button';
    add.addEventListener('click', function () { addToCart(add, err); });
    wrap.appendChild(add);
    return wrap;
  }
 
  function addToCart(btn, err) {
    var items = [], problems = [];
    var gid = 'C' + Date.now().toString(36).toUpperCase();
    for (var i = 0; i < st.n; i++) {
      var sh = st.shirts[i];
      var d = design(sh.design);
      if (!sh.size) { problems.push('pick a size for Shirt ' + (i + 1)); continue; }
      if (d.custom && !sh.text.trim()) { problems.push('type your text for Shirt ' + (i + 1)); continue; }
      var v = variant(sh.color, sh.size);
      if (!v) { problems.push('Shirt ' + (i + 1) + ' is not available in ' + sh.color + ' / ' + sh.size); continue; }
      var p = { 'Design': sh.design };
      if (d.custom) p['Your Text'] = sh.text.trim().toUpperCase();
      p['Combo'] = 'Shirt ' + (i + 1) + ' of ' + st.n + ' (' + gid + ')';
      p['_combo_ink'] = ink(sh.color) === 'rg' ? 'Red & Green' : 'Cream';
      items.push({ id: v.id, quantity: 1, properties: p });
    }
    if (problems.length) {
      err.textContent = 'Please ' + problems.join(', ') + '.';
      err.style.display = 'block';
      return;
    }
    err.style.display = 'none';
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    /* ask for the cart drawer's section HTML in the same request, like Horizon's own product form */
    var sectionIds = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (e) {
      if (e.dataset.sectionId && sectionIds.indexOf(e.dataset.sectionId) === -1) sectionIds.push(e.dataset.sectionId);
    });
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds.join(','), sections_url: location.pathname })
    }).then(function (r) {
      if (!r.ok) return safeJson(r).then(function (j) { throw new Error(j.description || j.message || ''); });
      return safeJson(r).then(function (added) {
        return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (x) { return x.ok ? safeJson(x) : { item_count: null }; })
          .then(function (cart) { return { cart: cart, sections: added.sections }; });
      });
    }).then(function (res) {
      var cart = res.cart;
      btn.disabled = false;
      btn.textContent = label;
      if (cart.item_count != null) {
        [].forEach.call(document.querySelectorAll('cart-icon'), function (e) {
          try { if (e.renderCartBubble) e.renderCartBubble(cart.item_count); } catch (x) {}
        });
        refreshDrawer(cart, res.sections, items);
      }
      var ok = root.querySelector('.atc-cb__ok');
      if (!ok) { ok = h('div', 'atc-cb__ok'); btn.parentNode.appendChild(ok); }
      ok.innerHTML = '';
      ok.appendChild(document.createTextNode('✓ ' + st.n + ' shirts added. '));
      var a = h('a', null, 'View cart'); a.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
      ok.appendChild(a);
    }).catch(function (e) {
      btn.disabled = false;
      btn.textContent = label;
      err.textContent = (e && e.message) || 'Could not add to cart, please try again.';
      err.style.display = 'block';
    });
  }
 
  /* Load a theme ES module from this classic script. Shopify's asset pipeline rewrites dynamic
     imports in assets into require calls, which the browser lacks, so use an inline module script. */
  var modSeq = 0;
  function withModule(spec, cb) {
    var key = '__atcCbMod' + (++modSeq);
    window[key] = function (m) { try { delete window[key]; } catch (e) { window[key] = null; } cb(m); };
    var s = document.createElement('script');
    s.type = 'module';
    s.textContent = 'import * as m from ' + JSON.stringify(spec) + '; window[' + JSON.stringify(key) + '](m);';
    document.head.appendChild(s);
  }
 
  /* Horizon's cart drawer only re-renders on the standard cart-lines-update event, so send one
     (same shape as assets/product-form.js) carrying the fresh section HTML */
  function refreshDrawer(cart, sections, items) {
    var done = false;
    withModule('@shopify/events', function (m) {
      var E = m.CartLinesUpdateEvent;
      if (!E) return;
      var d = E.createPromise();
      document.dispatchEvent(new E({
        action: 'add', context: 'product',
        lines: items.map(function (it) { return { merchandiseId: String(it.id), quantity: 1 }; }),
        promise: d.promise
      }));
      d.resolve({
        cart: E.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'atc-combo', sourceId: 'atc-combo', itemCount: items.length, sections: sections || {}, didError: false }
      });
      done = true;
    });
    /* fallback: re-render the drawer sections directly */
    setTimeout(function () {
      if (done) return;
      withModule('@theme/section-renderer', function (m) {
        [].forEach.call(document.querySelectorAll('cart-items-component'), function (e) {
          if (e.dataset.sectionId) m.sectionRenderer.renderSection(e.dataset.sectionId, { cache: false });
        });
      });
    }, 2500);
  }
 
  function scrollToStage() {
    var el = stage();
    if (el && el.getBoundingClientRect().bottom < 0) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
 
  function render() {
    root.innerHTML = '';
    root.appendChild(modeRow());
    body = h('div', 'atc-cb__body');
    var hn = h('div', 'atc-cb__h', 'How many shirts?');
    body.appendChild(hn);
    var nr = h('div', 'atc-cb__row');
    for (var n = MIN; n <= MAX; n++) {
      (function (n) {
        var b = pill(n + ' Shirts', n === st.n, tier(n) ? 'Save ' + tier(n) + '%' : null);
        b.addEventListener('click', function () { st.n = n; if (st.active >= n) st.active = n - 1; render(); });
        nr.appendChild(b);
      })(n);
    }
    body.appendChild(nr);
    for (var i = 0; i < st.n; i++) body.appendChild(card(i));
    body.appendChild(summary());
    root.appendChild(body);
    drawStage();
  }
 
  /* ---------- placement: right above the Teeinblue form ---------- */
  function anchor() {
    return $('.tee-form-wrapper') || $('variant-picker');
  }
  function place() {
    var a = anchor();
    if (!a || !a.parentNode) return false;
    if (root.parentNode !== a.parentNode || root.nextElementSibling !== a) a.parentNode.insertBefore(root, a);
    return true;
  }
  var placed = false;
  function tick() {
    if (place() && !placed) { placed = true; render(); }
    if (st.on) { var s = stage(); if (s && !s.firstChild) drawStage(); }
  }
  var q = false;
  new MutationObserver(function () {
    if (q) return; q = true;
    setTimeout(function () { q = false; tick(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
})();
 